import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { logError } from "../lib/log";
import * as apiClient from "../api";

export default function Referral() {
  const { code } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        const p = await apiClient.getReferral(code);
        localStorage.setItem("cristalda_ref", code);
        toast.success(`Benvenuto da ${p.name}!`);
      } catch (err) {
        logError("referral", err);
      } finally {
        navigate("/", { replace: true });
      }
    })();
  }, [code, navigate]);
  return <div className="min-h-screen flex items-center justify-center text-slate-400">Reindirizzamento...</div>;
}
